import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { Exercise } from '@/types/workouts'
import { TIME } from '@/types/timer'

@Component({})
export default class ExerciseTileComponent extends Vue {
  @Prop() exercise!: Exercise
  @Prop({ type: Number, default: 1}) exercisePosition!: number
  @Prop({ type: Number, default: 0}) workInterval!: number
  @Prop() partnerWorkout?: boolean

  get thumbnailUrl() {
    return `/exercises/${this.exercise.category}/${this.exercise.image}`
  }

  get measures() 
  {
    if (this.workInterval > 0) {
      if (Array.isArray(this.exercise.measures)) {
        if (this.exercise.measures.find(m => m.name == TIME.SEC) == undefined) {
          this.exercise.measures.unshift({name: TIME.SEC, description: this.workInterval.toString()})
        }
      } else {
        this.exercise.measures = [{name: TIME.SEC, description: this.workInterval.toString()}]
      }
    }
    return Array.isArray(this.exercise.measures) ? this.exercise.measures.slice(0,3) : null
  }

  get isTextOnly() {
    return this.exercise.only_text
  }

  get position() {
    if (this.partnerWorkout !== undefined) {
      return this.partnerWorkout ? 'B' : 'A'
    } else {
      return this.exercisePosition + 1
    }
  }
}